import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Upload,  Button,message, Divider,Typography,Select} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import {importFinance} from "../../model/loan/requests"
import storage from '../../utils/storage';
import { configs } from '../../config/config';
export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

const {  Paragraph} = Typography;
const Option = Select.Option;

class LoanFile extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            visiable: true,
            fileList: [],
            zone:"0:00"
        }
    };
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }

    beforeUpload = (file) => {
         if ( file.name.indexOf('.xlsx') === -1 ) {
            message.error('you can only upload "XLSX" format file ')
        }
        return false;
    };
    
    onChangeEvent = (info)=>{
         if ( info.file.name.indexOf('.xlsx') !== -1 ) {
            let fileList = [...info.fileList];
            fileList = fileList.slice(-1);
            if (fileList.length === 1) {
                this.setState({
                    visiable:false
                })
            }
            this.setState({ fileList })
        }
    }
    onRemoveEvent = (file)=>{
        const { fileList } = this.state;
        const index = fileList.indexOf(file);
        let newFileList = fileList.slice();
        newFileList.splice(index, 1);
        if (newFileList.length < 1) {
            this.setState({
                visiable: true
            })
        }
        this.setState({
            fileList: newFileList
        })
    };

    handlerSubmit = (e) => {
        const { fileList } = this.state;
        const formData = new FormData();
        fileList.forEach(file => {
            formData.append('file', file.originFileObj);
        });

        formData.append("zone",this.state.zone)
        importFinance(formData).then(res=>{
           if(res.data.code === 200){
                message.success("upload success")
                this.setState({
                    fileList:[],
                    visiable:true
                })
           }else{
               message.error("Upload Failed")
           }
        }).catch(err=>{
            message.error(err)
        })
    
    }

    handlerChange = (item) => {
        // we just need the first one
        let zone = item.split(",")[0]
        this.setState({
            zone:zone
        })
        
    }

    render() {
        const { visiable} = this.state;
        return (
            <>
                <BreadcrumbCustomer first='Multi Loan' second='Create' />
                <Typography>
                        <Paragraph>
                        · Function in this page is only for accounts with Operation Manager role.
                        </Paragraph>
                        <Paragraph>
                        · Before uploading the accounts billing data file, please make sure the table being of the standard format. Especially no new column is accepted.
                        </Paragraph>
                </Typography>
                <Divider />
                <Form
                    {...layout}
                    ref={this.formRef}
                >
                    <Form.Item label="TimeZone" name="timezone">
                        <Select 
                            onChange={this.handlerChange}
                        >
                        { configs.zone.map((items) => {
                                return (<Option attr={items.city} key={items.city} value={items.offset}> {items.cc + " [ "+items.offset+" ] "} </Option>)
                        })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                            label="Upload"
                        >
                            <Upload 
                                      name = 'filename'
                                      showPreviewIcon
                                      fileList = {this.state.fileList}
                                      onChange={this.onChangeEvent}
                                      onRemove = {this.onRemoveEvent}
                                      beforeUpload={this.beforeUpload}
                                      multiple={false}
                            >
                            <Button icon={<UploadOutlined />}>Click to upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button type="primary" 
                                onClick = {this.handlerSubmit}
                                disabled = {visiable}
                                style={{background: "#851dd6",color:"white" }}
                                
                            >
                                Submit
                            </Button>
                        </Form.Item>    
                </Form>    
            
            </>
        );
    }
}

export default LoanFile;